import React from 'react'

import { Rights } from 'app/appUserContextConstants'
import settings from 'app/settings'
import { useAppUserContext } from 'app/useAppUserContext'
import { DefaultHeaderMeta } from 'features/core/DefaultHeaderMeta'
import { CenterPanel, CenterPanelWrapper } from 'features/studio/ui/Layout'
import { Heading, Icon8, Section, Text } from 'legacy/v1/ui'

export const ErrorPage = () => {
    return (
        <>
            <DefaultHeaderMeta title="Error" />
            <CenterPanelWrapper hidePoweredBy>
                <CenterPanel>
                    <ErrorComponent />
                </CenterPanel>
            </CenterPanelWrapper>
        </>
    )
}

const ErrorComponent = () => {
    const { hasRight } = useAppUserContext()
    const showErrorReportDialog = hasRight(Rights.Admin.All)
    return (
        <Section centered style={{ marginBottom: '30px' }}>
            <Icon8
                icon="sad-cloud"
                iconStyle="material-outlined"
                displaySize="200"
                color="333333"
                noMargin
            />
            <Heading size="medium">Something went wrong</Heading>
            <Text style={{ maxWidth: '300px', textAlign: 'center' }}>
                Sorry, an unrecoverable error occurred.
            </Text>
            {showErrorReportDialog && (
                <Text style={{ maxWidth: '300px', textAlign: 'center' }}>
                    Please get in touch with Stacker support and we&apos;ll be able to help.
                </Text>
            )}
        </Section>
    )
}

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { caughtError: false }
    }

    static getDerivedStateFromError(_error) {
        return { caughtError: true }
    }

    componentDidCatch(error, errorInfo) {
        // Log error to console in development
        if (settings.debug) {
            console.error('Error caught by boundary:', error, errorInfo)
        }
    }

    render() {
        if (this.state.caughtError) {
            if (this.props.errorContent) {
                return this.props.errorContent
            }
            return this.props.app ? <ErrorPage /> : <ErrorComponent />
        }

        return this.props.children
    }
}
